"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fastlyOptions = exports.encodeImageFileName = exports.applyUrlParams = exports.appendQueryString = void 0;
const fastlyOptions = options => Object.entries({
  ...options,
  auto: 'webp',
  quality: 75
}).filter(([, v]) => Boolean(v)).reduce((acc, [key, value]) => ({
  ...acc,
  [key]: value
}), {});

/**
 * Creates a new URL string containing both, any existing plus supplied
 * URL parameters
 * @param {string} param0.url - URL. May contain ?url=parameters
 * @param {string} param0.baseUrl - Base URL to use only in case `url` doesn't already have a base/domain
 * @param {object} param0.urlParams - Additional URL parameters to apply to `url`
 * @param {boolean} param0.unique - If `true`, keeps param names unique. `overrideExisting` specifies
 *                                  how repeated params are handled. `false` by default
 * @param {boolean} param0.overrideExisting - Only has effect if `unique` === `true`
 *                                            If `true` (default), the new param values take precedence.
 *                                            If `false` existing values take precedence.
 * @returns string representation of the URL containing all the parameters
 * @example
 *    applyUrlParams({url: '/image.jpg', urlParams: {one: '1', two: '2'}})
 *    applyUrlParams({url: '/image.jpg?zero=0', urlParams: 'one=1&two=2'})

 *    applyUrlParams({
 *      url: '/image.jpg?zero=0',
 *      urlParams: '?zero=zero&one=1&two=2'
 *    }) // /image.jpg?zero=0&zero=zero&one=1&two=2
 *
 *    applyUrlParams({
 *      url: '/image.jpg?zero=0',
 *      baseUrl: 'http://test.com'
 *      urlParams: {zero: 'zero', one: '1', two: '2'},
 *      unique: true,
 *    }) // http://test.com/image.jpg/?zero=zero&one=1&two=2
 */
exports.fastlyOptions = fastlyOptions;
const applyUrlParams = ({
  url: urlStr,
  baseUrl,
  urlParams,
  unique = false,
  overrideExisting = true
}) => {
  // URL doesn't support relative paths, so add minimal base, then remove it later
  // NOTE: must be lowercase as URL downcases it
  const dummyBaseUrl = 'http://dummy.dummy';
  const dummyBaseUrlRegExp = new RegExp(`^${dummyBaseUrl}`);
  urlStr ??= '';
  baseUrl ||= dummyBaseUrl; // don't allow empty string

  let url;
  try {
    url = new URL(urlStr, baseUrl);
  } catch (e) {
    console.error(`Supplied url: ${urlStr}, baseUrl: ${baseUrl}`);
    console.error(e);
    return '';
  }
  const {
    searchParams: currentParams
  } = url;
  const additionalParams = new URLSearchParams(urlParams);
  let allParams;
  // prettier-ignore
  if (unique) {
    if (overrideExisting)
      // new param values take precedence
      allParams = new URLSearchParams({
        ...Object.fromEntries(currentParams),
        ...Object.fromEntries(additionalParams)
      });else
      // existing param values take precedence, order might change
      allParams = new URLSearchParams({
        ...Object.fromEntries(additionalParams),
        ...Object.fromEntries(currentParams)
      });
  } else
    // keep existing and new params in the same order and with possible dups
    allParams = new URLSearchParams([...currentParams, ...additionalParams]);

  // prettier-ignore
  url.search = allParams.toString().replace(/%2C/g, ',').replace(/%3A/g, ':');
  return url.toString().replace(dummyBaseUrlRegExp, '');
};
exports.applyUrlParams = applyUrlParams;
const appendQueryString = (url, urlParams) => applyUrlParams({
  url,
  urlParams,
  unique: false
});
exports.appendQueryString = appendQueryString;
const encodeImageFileName = path => {
  if (/\/images\//.test(path)) {
    const separator = '/';
    const parts = path.split(separator);
    const imageFileName = parts[parts.length - 1];
    return [...parts.slice(0, parts.length - 1), encodeURIComponent(imageFileName)].join(separator);
  }
  return path;
};
exports.encodeImageFileName = encodeImageFileName;